<template lang="pug">
  .component-invoice-list-filter-form.filter-form
    //pre {{search}}
    .entity-filters(v-if="$is('entity-filter')")
      select(v-model="search.status", v-on:change="filterInvoices")
        option(:value="null" selected) All statuses
        option(value="ON HOLD") On hold
        option(value="HOLDOVER PAYMENT") Holdover Payment
        option(value="PAID") Paid
        option(value="CANCELED") Canceled
        option(value="OVERDUE") Overdue
        option(value="SENT") Sent (Not paid)
        option(value="AWAITING PAYMENT") Awaiting Payment
        option(value="NO PAYMENT METHOD") No payment Method
    select(v-model="search.type", v-else-if="$is('type-filter')", v-on:change="filterInvoices")
      option(:value="null" selected) All types
      option(value="INVOICE") Invoice
      option(value="CREDIT NOTE") Credit Note
      option(value="PROFORMA") Proforma
    .row(v-else="")
      .columns
        date-range-picker(@input="dateRangeSelected")
      .columns
        search-entity(v-model="search.client_id", entity="clients" )
        input(type="text", placeholder="Final sectional / internal id", v-model="search.final_sectional")
      .column
        select(v-model="search.sectional")
          option(:value="null") All sectionals
          option(v-for="sectional in sectionals", :value="sectional") {{sectional}}
        is-module-enabled(module="aruba-italian-e-invoice")
          select(v-model="search.sdi", v-if="")
            option(:value="null" selected) Filtro Sdi
            option sdi-wait
            option sdi-rejected
            option sdi-not-sent

      .columns
        select(v-model="search.status")
          option(:value="null" selected) All statuses
          option(value="ON HOLD") On hold
          option(value="HOLDOVER PAYMENT") Holdover Payment
          option(value="PAID") Paid
          option(value="CANCELED") Canceled
          option(value="OVERDUE") Overdue
          option(value="SENT") Sent (Not paid)
          option(value="AWAITING PAYMENT") Awaiting Payment
          option(value="NO PAYMENT METHOD") No payment Method
        select(v-model="search.type")
          option(:value="null" selected) All types
          option(value="INVOICE") Invoice
          option(value="CREDIT NOTE") Credit Note
          option(value="PROFORMA") Proforma
          span Exclude proforma
      .columns.large-1.text-center
        InputSwitch(v-model="search.proforma", idEl='proforma'  @input="filterProforma")
          span Exclude proforma
      .columns.small-1.text-right
        a.fa.fa-filter.fa-2x(v-on:click="filterInvoices")
        is-module-enabled(module="italian-e-invoice")
          .download-zip(v-if="search.from !== null && search.to !== null")
            a(@click="downloadZip").fa.fa-file-archive-o.fa-2x

</template>
<script type="text/babel">
import {mapState} from 'vuex'
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import DatePicker from 'components/structure/DatePicker'
import SelectizeClient from '../lists/selectize/SelectizeClient'
import InputSwitch from '../InputSwitch'
import RangePicker from '../../RangePicker'
import ActionButton from '../ActionButton'
import IsModuleEnabled from '../../IsModuleEnabled'
import DateRangePicker from '../../DateRangePicker'
import SearchEntity from "../SearchEntity.vue";

export default {
  name: 'InvoiceListForm',
  components: {
    SearchEntity,
    DateRangePicker,
    IsModuleEnabled,
    ActionButton,
    RangePicker,
    InputSwitch,
    SelectizeClient,
    KeplerBackofficeSdk,
    DatePicker
  },
  data() {
    return {
      search: {
        client_id: null,
        from: null,
        to: null,
        status: null,
        sectional: null,
        type: null,
        proforma: null,
        sdi: null,
        final_sectional:null
      }
    }
  },
  mounted() {
  },
  methods: {
    selectClient(client) {
      this.search.client_id = client.id
    },
    unsetClient() {
      this.search.client_id = null
    },
    dateRangeSelected(range) {
      this.search.from = range.start
      this.search.to = range.end
    },
    filterProforma(val) {
      this.search.proforma = val
      this.filterInvoices()
    },
    filterInvoices() {
      var search = {}
      $.map(this.search, function (value, key) {
        if (value !== null && value !== '') {
          search[key] = value
        }
      })

      this.$emit('filterInvoices', search)
    },
    downloadZip() {
      const url = KeplerBackofficeSdk.invoices.archiveXml(this.search)
      window.open(url, '_blank')
    },
    bulkOperations() {
      this.$store.dispatch('setBulkFilters', Object.assign({}, this.search))
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    sectionals() {
      if (this.configuration.commercial == null) {
        return []
      }


      const numberFormat = this.configuration.commercial.commercial_invoice_number_format
      if (numberFormat == null) {
        return []
      }
      return this.configuration.commercial.commercial_invoice_number_format.value.map((item) => {
        return item.sectional
      })
    }
  }, props: {
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// InvoiceListForm.vue?3aa0ca6e